<template>
  <div id="forgetpassword">
    <Header />
    <section id="forgetpassword__content">
      <BlockTitle title="忘记密码" />
      <div id="forgetpassword__byEmail">
        <template v-if="forgetPasswordLayout === 'isNormal'">
          <label for="forgetpassword_user_account_id" :class="{'invalid': isInValidEmail}">
            <div class="label_title">
              帐号
              <span>*请输入英数，且不可少于4个</span>
            </div>
            <input 
              ref="account_id"
              type="email" 
              id="forgetpassword_user_account_id" 
              v-model="account_id" 
              @blur="handleEmail">
          </label>

          <label for="forgetpassword_user_birthday" :class="{'invalid': isInValidBirthday }">
            <div class="label_title">
              生日
              <span>*(1990/01/01)</span>
            </div>

            <div class="label_birthday">
              <input type="number" max="2990" min="1990" v-model="birthday_year">
              <input type="number" max="12" min="1" v-model="birthday_month">
              <input type="number" max="31" min="1" v-model="birthday_day">
            </div>
          </label>

          <div class="btns">
            <div class="btn submit" @click="handleSubmit">送出</div>
          </div>
        </template>
        <template v-if="forgetPasswordLayout === 'isError'">
          <div class="desc error">帐号或生日不符合</div>
          <div class="btns">
            <div class="btn" @click="reset">继续找回密码</div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import { 
  mapGetters,
  mapActions,
} from 'vuex';

// @ is an alias to /src
import Header from "@/components/Header.vue";
import BlockTitle from "@/components/BlockTitle.vue";

export default {
  name: "forgetpassword",
  components: {
    Header,
    BlockTitle
  },
  data() {
    return {
      isInValidEmail: false,
      isInValidBirthday: false,
      account_id: '',

      minutes: '',
      seconds: '',

      birthday_year: '',
      birthday_month: '',
      birthday_day: '',
    }
  },
  computed: {
    ...mapGetters([
      'forgetPasswordLayout'
    ])
  },
  mounted() {},
  methods: {
    ...mapActions([
      'forgetPassword',
      'setForgetPasswordLayout'
    ]),

    handleBirthday() {
      this.isInValidBirthday = !(
        (this.birthday_year && +this.birthday_year > 0) &&
        (this.birthday_month && +this.birthday_month > 0) &&
        (this.birthday_day && +this.birthday_day > 0)
      )
    },

    handleEmail() {
      if (this.account_id === '') {
        this.isInValidEmail = true
        return 
      }

      this.isInValidEmail = !/^[a-zA-Z0-9._]{4,254}$/.test(this.account_id)
    },

    handleSubmit() {
      this.handleEmail()
      this.handleBirthday()

      if (
        this.isInValidEmail === false && 
        this.isInValidBirthday === false
      ) {
        let formData = new FormData()

        formData.append('account_id', this.account_id)
        formData.append('birthday', `${this.birthday_year}/${this.birthday_month}/${this.birthday_day}`)

        this.forgetPassword({
          formData,
          router: this.$router
        })
      }
    },

    reset() {
      this.setForgetPasswordLayout({
        layout: 'isNormal'
      })

      this.isInValidEmail = false
      this.isInValidBirthday = false
      this.account_id = ''

      this.clickTimes = 1

      this.birthday_year = ''
      this.birthday_month = ''
      this.birthday_day = ''

      this.$nextTick(() => {
        this.$refs.account_id.focus()
      })
    }
  }
};
</script>
